import rongHoApi from "apis/rongho-api";
import { RootState, useAppSelector } from "cache/store";
import { PayloadTopicRongHo } from "models/rong-ho-model";
import { ChatItemTXCB, ParamBetRongHo, PayloadBodyUserQueueTXCB, PayloadHistoryMyBetTXCB } from "models/txcb-model";
import { useEffect, useRef, useState } from "react";
import rhSocket from "socket/rongho-socket";
import './rongho.scss';
import BoardRongho from "./board-rongho";
import BoxChatMinigame from "components/BoxChatMinigame/box-chat-minigame";
import { chatSuggestRongHo } from "./rongho-function";
import Modal from "components/modal/Modal";
import HisPhienRongHo from "./lsp/his-phien-rongho";
import HistoryMyBetRongHo from "./lsc/his-bet-rongho";
import HDRH from "./hd/hd";
import MiniRank from "../bxh/bxh";

interface Props {
    onClose: () => void;
    onChangeMsg: (inputData: string) => void;
}

export default function MiniRH(props: Props) {
    const { onClose, onChangeMsg } = props;

    const maintainRH = useRef(false);
    const hisPhienData = useRef<{ id: string; result: string[] }[]>([]);
    const pageDom = useRef<HTMLDivElement>(null);

    const { stompRH } = useAppSelector((state: RootState) => state.socket);
    const { userInfo, tokenRH } = useAppSelector((state: RootState) => state.auth);

    const [topicData, setTopicData] = useState({} as PayloadTopicRongHo);
    const [TXCBUserQueueData, setTXCBUserQueueData] = useState({} as PayloadBodyUserQueueTXCB);

    const [showRank, setShowRank] = useState(false);
    const [rankData, setRankData] = useState<any[]>([]);

    const [showHisPhien, setShowHisPhien] = useState(false);

    const [showHistoryMyBet, setShowHistoryMyBet] = useState(false);

    const [showHelp, setShowHelp] = useState(false);

    const [showChat, setShowChat] = useState(false);
    const [chatList, setChatList] = useState<ChatItemTXCB[]>([]);

    const [statsData, setStatsData] = useState<{ id: string; result: number }[]>([]);

    useEffect(() => {
        if (stompRH) {
            stompRH.subscribe('/topic/rh', (data: { body: string }) => {
                const body: PayloadTopicRongHo = JSON.parse(data.body);
                if (body.cmd === 12 && body.rs) {
                    maintainRH.current = true;
                }

                //chat response
                if (body.cmd === 11) {
                    setChatList((list) => {
                        if (list.length > 0) {
                            return [...list, body.data[body.data.length - 1]];
                        } else {
                            return [...list, ...body.data];
                        }
                    });
                }
                setTopicData(body);
            });

            stompRH.subscribe('/user/queue/rh', (data: any) => {
                const body: PayloadBodyUserQueueTXCB = JSON.parse(data.body);
                setTXCBUserQueueData(body);

                //chat
                if (body.cmd === 11) {
                    setChatList(body.data as any[]);
                }
            });

            setTimeout(() => {
                subscribeLSP('/topic/rh-lichsuphien');
                subscribeLSP('/topic/public');
            }, 150);
        }
    }, [stompRH]);

    useEffect(() => {
        const getStatsRecord = async () => {
            try {
                const { data } = await rongHoApi.getStatistic();
                if (Array.isArray(data) && data.length > 0) {
                    const hisPhienList: any[] = data;
                    setStatsData(hisPhienList.reverse());
                }
            } catch (error) {
                console.log(error);
            }
        };
        getStatsRecord();
    }, []);

    const subscribeLSP = (topic: string) => {
        rhSocket.sendMessage(topic, {});
    };

    const submitBet = (topic: string, payload: ParamBetRongHo) => {
        if (stompRH && stompRH.connected) {
            payload = { ...payload, userId: userInfo.id, loginname: userInfo.loginname, userType: userInfo.usertype };
            rhSocket.sendMessage(topic, payload);
        }
    };

    const getRank = async () => {
        setShowRank(true);
        const params = {
            type: 1,
            access_token: tokenRH || '',
        };
        try {
            const { data } = await rongHoApi.getRank(params);
            const topTen = (data as any)
                .filter((item: any) => item.amount && item.amount > 0)
                .sort((a: any, b: any) => b['amount'] - a['amount'])
                .slice(0, 10);
            setRankData(topTen);
        } catch (error) {
            console.log(error);
        }
    };

    const handleGetMsg = (msg: any) => {
        onChangeMsg(msg);
    };

    const sendChat = (msg: string, cb: () => void) => {
        if (Number(userInfo.balance) < 20000) {
            handleGetMsg('Số dư của bạn phải trên 20,000 để có thể chat!');
            return;
        }
        const payload = {
            u: userInfo.loginname,
            m: msg,
        };
        rhSocket.sendMessage('/topic/rh-chats', payload);
    };

    return (
        <>
            <div className={`rongho-page`}>
                <div className="board-game" ref={pageDom}>
                    <div className="btn-header-list">
                        <div className="btn-group">
                            <button className="btn-reset" onClick={getRank}>
                                <img src={require(`assets/images/txcb/btn-rank.png`)} alt="coin" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowHisPhien(true)}>
                                <img src={require(`assets/images/txcb/btn-tk-phien.png`)} alt="coin" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowHistoryMyBet(true)}>
                                <img src={require(`assets/images/txcb/btn-his-bet.png`)} alt="coin" />
                            </button>
                        </div>
                        <div className="btn-group">
                            <button className="btn-reset" onClick={() => setShowHelp(true)}>
                                <img src={require(`assets/images/txcb/btn-help.png`)} alt="coin" />
                            </button>
                            <button className="btn-reset" onClick={() => setShowChat(!showChat)}>
                                {!showChat ? (
                                    <img src={require(`assets/images/txcb/chat-off.png`)} alt="coin" />
                                ) : (
                                    <img src={require(`assets/images/txcb/chat-on.png`)} alt="coin" />
                                )}
                            </button>
                            <button className="btn-reset" onClick={onClose}>
                                <img src={require(`assets/images/txcb/btn-close.png`)} alt="coin" />
                            </button>
                        </div>
                    </div>
                    <BoardRongho
                        balance={userInfo.balance}
                        bodyTopic={topicData}
                        userQueue={TXCBUserQueueData}
                        onBet={submitBet}
                        lspData={hisPhienData.current}
                        onUpdatePhien={(value: any) => (hisPhienData.current = value)}
                        ref={pageDom}
                        onClose={() => onClose} 
                        onChangeMsg={handleGetMsg}
                    />
                </div>
                <div className={`chat-box ${showChat ? 'show' : ''}`}>
                    <BoxChatMinigame
                        chatList={showChat ? chatList : []}
                        chatSuggest={chatSuggestRongHo}
                        onSend={sendChat}
                        onClose={() => setShowChat(false)}
                    />
                </div>
            </div>

            <Modal isShow={showRank} onClose={() => setShowRank(false)} width="920px">
                <MiniRank onClose={() => setShowRank(false)} rankList={rankData} />
            </Modal>

            <Modal isShow={showHisPhien} onClose={() => setShowHisPhien(false)} width="920px">
                <HisPhienRongHo onClose={() => setShowHisPhien(false)} data={hisPhienData.current} />
            </Modal>

            <Modal isShow={showHelp} onClose={() => setShowHelp(false)} width="920px">
                <HDRH onClose={() => setShowHelp(false)} />
            </Modal>

            <Modal isShow={showHistoryMyBet} onClose={() => setShowHistoryMyBet(false)} width="920px">
                <HistoryMyBetRongHo
                    isShow={showHistoryMyBet}
                    onClose={() => setShowHistoryMyBet(false)}
                />
            </Modal>
        </>
    )
}